<template>
  <div class="campaign-metrics-container">
    <div v-for="(metric, index) in metrics" :key="metric.title" :class="`metric-item item-${index}`">
      <div class="item-title">{{ metric.title }}</div>
      <div class="item-description">{{ `(${metric.tooltipText})` }}</div>
      <div class="item-metric">
        <span v-if="metric.isCurrency" class="card-number description">R$</span>
        <span class="card-number">{{ metric.number }}</span>
      </div>
      <div class="item-metric-percent">
        <span class="percent-text" :class="getPercentageClass(metric)">{{ metric.percent }}</span>
        <span class="percent-description">{{ metric.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignMetrics',
  props: {
    metrics: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  methods: {
    percentNumber(item) {
      return item.percent ? Number(item.percent.substring(0, item.percent.length - 1).replaceAll(',', '.')) : 0
    },
    getPercentageClass(item) {
      if (!item.usePercentageColor || this.percentNumber(item) === 0) {
        return 'unset-color'
      }
      return this.percentNumber(item) > 0 ? 'positive' : 'negative'
    },
  },
}
</script>

<style lang="scss" scoped>
.campaign-metrics-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  .item-0,
  .item-1 {
    border-bottom: solid 1px $cinza-l40;
  }
  .item-1,
  .item-3 {
    border-left: solid 1px $cinza-l40;
  }
  .metric-item {
    padding: 18px 40px 22px 76px;
    width: 400px;
    height: 185px;
    .item-title {
      color: $cinza-d10;
      font-size: 18px;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: 0.16px;
    }
    .item-description {
      color: $cinza-d10;
      font-size: 14px;
      font-weight: 400;
      line-height: 120%;
      letter-spacing: 0.12px;
    }
    .item-metric {
      .card-number {
        color: $cinza-0;
        font-size: 34px;
        font-weight: 400;
        letter-spacing: 0.32px;
      }
      .description {
        color: $cinza-l40;
        margin-right: 2px;
      }
    }
    .item-metric-percent {
      span {
        line-height: 120%;
        font-size: 16px;
      }
      .percent-text {
        font-weight: 700;
        margin-right: 2px;
      }
      .percent-description {
        color: $cinza-0;
        font-weight: 400;
      }
    }
  }
}
.unset-color {
  color: $cinza-d10;
}
.positive {
  color: $verde-0;
}
.negative {
  color: $vermelho-0;
}
</style>
